import React from 'react';
import useNotes from '../../../../../../hooks/api/useNotes';
import { useIsOrganizationAdmin } from '../../../../../../hooks/api/useOrganization';
import { AnimateLoadedContent } from '../../../../../v2BaseComponents/Loader';
import NoteDetails from '../../../../../shared/Notes/NoteDetails';
import { getIntl } from '../../../../../../utils/intl';
import { PRScrollView } from '../../../../../shared/Scroll';

const intl = getIntl('resource-notes-notes-details', {
    delete: 'Delete Note',
});

export type NoteDetailsSideDrawerContentOwnProps = {
    onEditNote: () => void;
    onClose: (force: boolean) => void;
    noteId: string;
};

export type NoteDetailsSideDrawerContentProps = NoteDetailsSideDrawerContentOwnProps;

const NoteDetailsSideDrawerContent: React.FC<NoteDetailsSideDrawerContentProps> = ({ onEditNote, onClose, noteId }) => {
    const { isLoading, note, deleteNote, isDeletingNote } = useNotes({
        noteId: noteId,
        onNoteLoadFailure: () => {
            onClose(false);
        },
    });

    const hasNoteEditPermission = useIsOrganizationAdmin();
    return (
        <AnimateLoadedContent isLoading={isDeletingNote || isLoading || !note}>
            {() =>
                note ? (
                    <PRScrollView
                        style={{ width: '100%', height: '100%' }}
                        contentContainerStyle={{ width: '100%', minHeight: '100%' }}
                    >
                        <NoteDetails
                            note={note}
                            canEdit={!isDeletingNote && !note.isSystemGenerated}
                            onEdit={onEditNote}
                            editActions={[
                                {
                                    icon: 'Trash2',
                                    title: intl('delete'),
                                    onPress: () => {
                                        deleteNote(noteId);
                                        onClose(false);
                                    },
                                    isDisabled: isDeletingNote,
                                    show: hasNoteEditPermission,
                                    testID: 'delete-note-button',
                                },
                            ]}
                            disableComments
                        />
                    </PRScrollView>
                ) : null
            }
        </AnimateLoadedContent>
    );
};

export default React.memo(NoteDetailsSideDrawerContent);
